import { Component, OnInit,  HostListener, Inject } from "@angular/core";
import { trigger, state, animate, transition, style } from "@angular/animations";
import { reduce } from "rxjs/operators";
import { Subscriber, Subscription } from "rxjs";
import { SharedFormService } from 'src/app/shared-utility/services/shared-form.service';
import { Router } from "@angular/router";
import { DOCUMENT } from '@angular/common'; 


@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss", "./footer.component.ipad.scss"]
})
export class FooterComponent implements OnInit {
  public screenWidth: any;  
  currYear: number;
  openbox: boolean = false;
  public show: boolean = false;
  public buttonName: any = "Show More";
  arrowIcon: boolean = false;
  displayDialog:boolean = false;
  isLogedIn: boolean = true;
  showChatIcon: boolean = false;
  iframeVisible: boolean = false;
  maximizeWebChat: boolean = false;
  chatUrl: string = ''; 
  eventSub: Subscription;
  constructor(private formData: SharedFormService, public router: Router, @Inject("WEBCHAT_URL") private webChatUrl: any,) {
    this.chatUrl = this.webChatUrl.webChatUrl + `?username=${localStorage.getItem('username')}`
  }

  ngOnInit() {
    this.screenWidth = window.innerWidth;  
    const today = new Date();
    this.currYear = today.getFullYear();
  }
  ngDoCheck(){
    const username = localStorage.getItem("username") ;
    this.showChatIcon = username && username.length && this.router.url !=='/patient-esignature-authorization' ? true : false;
  }
  Dialog(){
    this.displayDialog = true;
  }
  toggle() {
    this.show = !this.show;

    // CHANGE THE NAME OF THE BUTTON.
    if (this.show) {
      this.buttonName = "Show Less";
      this.arrowIcon = true;
    } else {
      this.buttonName = "Show More";
      this.arrowIcon = false;
    }
  }
  @HostListener('window:resize', ['$event'])  
  onResize(event) {  
    this.screenWidth = window.innerWidth;
  }  

  startChatBtn() {
    setTimeout(() => {
      // var inputField = document.getElementById("iwt-chat-form-panel-anonymous-identifier");
      const iFrame = document.getElementById('webchatId') as HTMLIFrameElement;
      const iFrameContentWindow = iFrame.contentWindow;
      const iFrameContentWindowDocument = iFrameContentWindow.document;
      const chatBtn = iFrameContentWindowDocument.getElementsByName("iwt-form-submit-button")[0];
      // console.log(chatBtn);
    }, 0);
    // const iframe = document.getElementById("webchatId");
    // const elmnt = iframe.contentWindow.document.getElementsByName("iwt-form-submit-button")[0];
    // console.log(elmnt);
  }
  toggleIframe() {
    this.iframeVisible = !this.iframeVisible;
    this.startChatBtn();
  }
  togglemaximizeWebChat() {
    this.maximizeWebChat = !this.maximizeWebChat;
  } 
 

}
